import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';

import { LoginComponent } from './login';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { AuditTrailComponent } from './components/auditTrail/audit-trail/audit-trail.component';
import { AuditGetSessionComponent } from './components/audit-get-session/audit-get-session.component';

const routes: Routes = [
  {
    path: 'search',
    component: SearchPanelComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'audit',
    component: AuditTrailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'auditsession',
    component: AuditGetSessionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  { 
    path: 'unauthorized', 
    component: LoginComponent
  },
  {
    path: 'unauthorized/:returnUrl',
    component: LoginComponent
  },
  {
    path: '',
    redirectTo: '/search',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  }
];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
